import React from 'react';
import { connect } from "react-redux";
import { updateData } from "../actions";
import Template from "react-dynamic-html";
import ControlService from '../../helper/controlservice';

const _ = require("lodash");

class Html extends React.PureComponent {
    state = {
        pagesearchtext: null,
        htmlData: {}
    }
    componentDidUpdate(prevProps, prevState) {
        this.updateHtmlData();
    }

    updateHtmlData() {
        const { control, formid, token } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        var htmlData = {};
        if (Array.isArray(control.mappingFields)) {
            control.mappingFields.map((item) => {
                if (item.formattype === 'currency')
                    htmlData[item.htmlKey] = ControlService().numberToCommas(data[item.dataKey] ? data[item.dataKey] : item.defaultvalue);

                else
                    htmlData[item.htmlKey] = data[item.dataKey] ? data[item.dataKey] : item.defaultvalue;
            });
            control.mappingFields.map((item) => {
                if (item.hideemptyornull) {
                    if (!htmlData[item.htmlKey]) {
                        debugger;
                        delete htmlData[item.htmlKey];
                    }
                }
            });

            if (JSON.stringify(htmlData) != JSON.stringify(this.state.htmlData)) {
                this.setState({ htmlData: htmlData });
            }
        }
    }

    componentDidMount() {
        if (window.location.host) {
            var _localStorage = localStorage.hasOwnProperty(window.location.href) ? localStorage.getItem(window.location.href) : null;
            if (_localStorage) {
                this.setState({
                    pagesearchtext: _localStorage
                })
            } else {
                var pagesearchtext = localStorage.hasOwnProperty('pagesearchtext') ? localStorage.getItem('pagesearchtext') : null;
                if (pagesearchtext) {
                    localStorage.setItem(window.location.href, pagesearchtext);
                    this.setState({
                        pagesearchtext: pagesearchtext
                    })
                }
            }
        }
        this.updateHtmlData();
    }

    render() {
        const { control } = this.props;
        const { htmlData } = this.state;
        return (
            <React.Fragment>
                {control.htmlStyle && <style>{control.htmlStyle}</style>}
                {control.htmlCode &&
                    <Template
                        className={'html-templet ' + (control.customClass && control.customClass)}
                        string={control.htmlCode}
                        values={htmlData}
                    />
                }
            </React.Fragment>
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(Html);